let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eIAVb")).then(() => parcelRequire('4EXSW'));